import type { DynamicProduct, ProductVariation } from 'models/productsReferential';
import type { Action } from 'state/actions';

import type { ProductsReferentialState } from './productsReferential.model';
import { initialProductsReferentialState } from './productsReferential.model';

export function productsReferentialReducer(
  state: ProductsReferentialState = initialProductsReferentialState,
  action: Action,
): ProductsReferentialState {
  switch (action.type) {
    case 'PRODUCTS_REFERENTIAL_REQUESTED':
      return { ...state, status: 'not_yet_loaded' };
    case 'PRODUCTS_REFERENTIAL_LOADED':
      return { ...state, ...action.productsReferential, status: 'loaded' };
    case 'PRODUCTS_REFERENTIAL_LOADING_FAILED':
      return { ...state, status: 'loading_failed' };
    case 'DYNAMIC_PRODUCTS_LOADED':
      return { ...state, dynamic: action.dynamicProducts.map(mapToProductVariation) };
    default:
      return state;
  }
}

function mapToProductVariation(dynamicProduct: DynamicProduct): ProductVariation {
  return {
    productType: dynamicProduct.instrumentName,
    commercialProductType: dynamicProduct.commercialInstrumentName,
    productSubType: dynamicProduct.instrumentContractName,
    commercialProductSubType: dynamicProduct.commercialInstrumentContractName,
    wrapper: dynamicProduct.wrapper,
    assetTypes: dynamicProduct.supportedAssetTypes,
    requestType: dynamicProduct.requestType,
    isStatified: dynamicProduct.isStatified,
  };
}
